import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
export function Location() {
  return <section id="ubicacion" className="py-[120px] px-[5%] bg-gris-medio" data-id="element-125">
      <FadeIn className="text-center mb-[70px]" data-id="element-126">
        <span className="inline-block bg-azul-neon/10 border border-azul-neon/30 text-acento text-[12px] font-semibold tracking-[2px] uppercase px-[16px] py-[6px] rounded-full mb-[18px]" data-id="element-127">
          Dónde estamos
        </span>
        <h2 className="font-rajdhani text-[clamp(32px,4vw,52px)] font-bold leading-[1.1] mb-[16px]" data-id="element-128">
          Vení a <span className="text-acento" data-id="element-129">Visitarnos</span>
        </h2>
        <p className="text-texto-gris text-[16px] max-w-[520px] mx-auto leading-[1.7]" data-id="element-130">
          En el corazón de San Luis, listos para atenderte.
        </p>
      </FadeIn>

      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.5fr] gap-[50px] items-start" data-id="element-131">
        <FadeIn className="flex flex-col gap-[30px]" data-id="element-132">
          <div className="bg-gris-oscuro border border-white/5 rounded-[14px] p-[24px] flex gap-[18px] items-start transition-all duration-300 hover:border-azul-neon/30" data-id="element-133">
            <div className="w-[46px] h-[46px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[12px] flex items-center justify-center shrink-0" data-id="element-134">
              <i className="fas fa-map-marker-alt text-acento text-[18px]" data-id="element-135"></i>
            </div>
            <div data-id="element-136">
              <h4 className="font-rajdhani text-[17px] font-bold mb-[6px]" data-id="element-137">
                Dirección
              </h4>
              <p className="text-texto-gris text-[14px] leading-[1.6]" data-id="element-138">
                Maipú 766, entre Pringles y Junín
                <br data-id="element-139" />
                San Luis, Argentina
              </p>
            </div>
          </div>

          <div className="bg-gris-oscuro border border-white/5 rounded-[14px] p-[24px] flex gap-[18px] items-start transition-all duration-300 hover:border-azul-neon/30" data-id="element-140">
            <div className="w-[46px] h-[46px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[12px] flex items-center justify-center shrink-0" data-id="element-141">
              <i className="fas fa-clock text-acento text-[18px]" data-id="element-142"></i>
            </div>
            <div className="w-full" data-id="element-143">
              <h4 className="font-rajdhani text-[17px] font-bold mb-[6px]" data-id="element-144">
                Horarios de Atención
              </h4>
              <table className="w-full border-collapse mt-[8px]" data-id="element-145">
                <tbody data-id="element-146">
                  <tr className="border-b border-white/5" data-id="element-147">
                    <td className="py-[8px] text-[14px] text-blanco font-medium" data-id="element-148">
                      Lunes a Viernes
                    </td>
                    <td className="py-[8px] text-[14px] text-texto-gris" data-id="element-149">
                      <span className="bg-[#22c55e]/15 text-[#4ade80] border border-[#22c55e]/30 px-[10px] py-[3px] rounded-full text-[11px] font-semibold" data-id="element-150">
                        Abierto
                      </span>
                    </td>
                    <td className="py-[8px] text-[14px] text-texto-gris text-right" data-id="element-151">
                      9:00 — 13:00 / 14:00 — 19:30 hs
                    </td>
                  </tr>
                  <tr className="border-b border-white/5" data-id="element-152">
                    <td className="py-[8px] text-[14px] text-blanco font-medium" data-id="element-153">
                      Sábados
                    </td>
                    <td className="py-[8px] text-[14px] text-texto-gris" data-id="element-154"></td>
                    <td className="py-[8px] text-[14px] text-texto-gris text-right" data-id="element-155">
                      9:00 — 13:00 hs
                    </td>
                  </tr>
                  <tr data-id="element-156">
                    <td className="py-[8px] text-[14px] text-blanco font-medium" data-id="element-157">
                      Domingos
                    </td>
                    <td className="py-[8px] text-[14px] text-texto-gris" data-id="element-158"></td>
                    <td className="py-[8px] text-[14px] text-texto-gris text-right" data-id="element-159">
                      Cerrado
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-gris-oscuro border border-white/5 rounded-[14px] p-[24px] flex gap-[18px] items-start transition-all duration-300 hover:border-azul-neon/30" data-id="element-160">
            <div className="w-[46px] h-[46px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[12px] flex items-center justify-center shrink-0" data-id="element-161">
              <i className="fab fa-whatsapp text-acento text-[18px]" data-id="element-162"></i>
            </div>
            <div data-id="element-163">
              <h4 className="font-rajdhani text-[17px] font-bold mb-[6px]" data-id="element-164">
                Contacto Directo
              </h4>
              <a href="https://wa.me/5492664261245" target="_blank" rel="noreferrer" className="text-texto-gris text-[14px] leading-[1.6] no-underline transition-colors duration-300 hover:text-acento" data-id="element-165">
                Escribinos por WhatsApp →
              </a>
            </div>
          </div>

          <div className="bg-gris-oscuro border border-white/5 rounded-[14px] p-[24px] flex gap-[18px] items-start transition-all duration-300 hover:border-azul-neon/30" data-id="element-166">
            <div className="w-[46px] h-[46px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 rounded-[12px] flex items-center justify-center shrink-0" data-id="element-167">
              <i className="fab fa-instagram text-acento text-[18px]" data-id="element-168"></i>
            </div>
            <div data-id="element-169">
              <h4 className="font-rajdhani text-[17px] font-bold mb-[6px]" data-id="element-170">
                Instagram
              </h4>
              <a href="https://instagram.com/randazzoautomotor" target="_blank" rel="noreferrer" className="text-texto-gris text-[14px] leading-[1.6] no-underline transition-colors duration-300 hover:text-acento" data-id="element-171">
                @randazzoautomotor →
              </a>
            </div>
          </div>
        </FadeIn>

        <FadeIn className="rounded-[16px] overflow-hidden border border-azul-neon/30 shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(37,99,235,0.1)] h-[380px] lg:h-[450px] relative" data-id="element-172">
          <div className="absolute top-[16px] left-[16px] bg-[#0f1117]/90 border border-azul-neon/40 rounded-[10px] px-[16px] py-[10px] flex items-center gap-[8px] text-[13px] font-semibold z-10 pointer-events-none" data-id="element-173">
            <i className="fas fa-map-marker-alt text-acento" data-id="element-174"></i>
            Randazzo Automotor
          </div>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3332.0!2d-66.3378!3d-33.2936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDE3JzM3LjAiUyA2NsKwMjAnMTYuMSJX!5e0!3m2!1ses!2sar!4v1700000000000!5m2!1ses!2sar&q=Maip%C3%BA+766,+San+Luis,+Argentina" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Randazzo Automotor - Maipú 766, San Luis" className="w-full h-full border-none filter invert-[90%] hue-rotate-[180deg] saturate-[1.2]" data-id="element-175"></iframe>
          <a href="https://www.google.com/maps/dir/?api=1&destination=Maip%C3%BA+766,+San+Luis,+Argentina" target="_blank" rel="noreferrer" className="absolute bottom-[16px] right-[16px] bg-gradient-primary text-white no-underline px-[20px] py-[12px] rounded-[10px] text-[13px] font-semibold flex items-center gap-[8px] z-10 transition-all duration-300 shadow-[0_4px_20px_rgba(26,79,219,0.4)] hover:-translate-y-[2px] hover:shadow-[0_8px_30px_rgba(26,79,219,0.6)]" data-id="element-176">
            <i className="fas fa-directions" data-id="element-177"></i>
            Cómo llegar
          </a>
        </FadeIn>
      </div>
    </section>;
}